import React, { useEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';

export const VideoPlayer = ({ url, showControls }) => {
    const [handlePlaying, setHandlePlaying] = useState(false);

    const handlePlay = () => {
        setHandlePlaying(true);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [url]);

    return (
        <>
            <ReactPlayer
                url={url}
                controls={showControls}
                playing={handlePlaying}
                playIcon={<PlayCircleIcon sx={{ color: 'var(--white-color)', fontSize: 80 }} />}
                onClickPreview={handlePlay}
                width="100%"
                height="100%"
            />
        </>
    );
};
